import {
  createContext,
  useCallback,
  useContext,
  useRef,
  useState,
} from "react";

const DirtyRowsContext = createContext(null);

export const DirtyRowsProvider = ({ children }) => {
  const [hasDirtyRows, setHasDirtyRows] = useState(false);
  const dirtySetRef = useRef(new Set());

  const reportDirty = useCallback((rowId, isDirty) => {
    const set = dirtySetRef.current;
    if (isDirty) {
      set.add(rowId);
    } else {
      set.delete(rowId);
    }
    setHasDirtyRows(set.size > 0);
  }, []);

  return (
    <DirtyRowsContext.Provider value={{ hasDirtyRows, reportDirty }}>
      {children}
    </DirtyRowsContext.Provider>
  );
};

export const useDirtyRows = () => {
  const ctx = useContext(DirtyRowsContext);
  return ctx || { hasDirtyRows: false, reportDirty: () => {} };
};
